//攻略请求

import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
// import { debuglog } from 'util';
import qs from "qs"; // 根据需求是否导入qs模块

const strategy = {
    // 攻略列表
    guideList(params) {
        return axios.get(`${base.fm}/travel_guide/list`, {
            params: params,
        });
    },
    guideDetail(params) {
        return axios.get(`${base.fm}/travel_guide/guideDetail`, {
            params: params,
        });
    },

    //商品详情
    commodityDetail(params) {
        return axios.get(`${base.fm}/store_commodity/detail`, {
            params: params,
        })

    },
     ticketRefresh(params) {
        return axios.get(`${base.fm}/store_order/ticket/refresh`, {
            params: params,
        })

    },
    //商品方案组合
    storeOrderSkuList(params) {
        return axios.get(`${base.fm}/store_order/sku`, {
            params: params,
        })
    },
    //日历
    storeOrderDateSchemeList(params) {
        return axios.get(`${base.fm}/store_order/date_scheme/list`, {
            params: params,
        })

    },
    //获取商品可購買日期
    storeOrderDateOrderList(params) {
        return axios.get(`${base.fm}/store_order/date/list`, {
            params: params,
        })

    },

    //订单信息接口
    storeOrderReservePeopleInfo(params) {
        return axios.get(`${base.fm}/store_order/commodity/reserve_people_info`, {
            params: params,
        })

    },
    //支付状态接口
    storeOrderPayStatus(params) {
        return axios.get(`${base.fm}/store_order/my_order/status`, {
            params: params,
        })

    },

    //优惠券接口
    storeCouponCenterList(params) {
        return axios.get(`${base.fm}/coupon/center/list`, {
            params: params,
        })
    },
    //领取优惠券
    storeGetCoupon(params) {
        return axios.post(`${base.fm}/coupon/get_coupon`, qs.stringify(params))
    },
    //订单信息
    couponListData(params) {
        return axios.get(`${base.fm}/store_order/coupon/list_data`, {
            params: params,
        })
    },
    //请求积分接口
    storeOrderCommdityIntegralInfo(params) {
        return axios.get(`${base.fm}/store_order/commodity/integral_info`, {
            params: params,
        })
    },
    //兑换优惠券码
    couponExchangeCode(params) {
        return axios.post(`${base.fm}/coupon/exchange_code`, qs.stringify(params))

    },
    //修改积分
    storeOrderExchangeIntegral(params) {
        return axios.get(`${base.fm}/store_order/commodity/integral_exchange`, { params: params })

    },
    //支付接口
    //创建订单
    storeOrderCreateOder(params) {
        return axios.post(`${base.fm}/store_order/create_order`, qs.stringify(params));
    },
    //微信支付
    storeOrderWXPayPrepayResult(params) {
        return axios.post(`${base.fm}/store_pay/wx/prepay_order_result`, qs.stringify(params));
    },
    //支付宝支付store_pay/ali/prepay_order_result
    storeOrderALIPayPrepayResult(params) {
        return axios.post(`${base.fm}/store_pay/ali/prepay_order_result`, qs.stringify(params));
    },
    //更新价格
    updateOrderPrice(params) {
        return axios.get(`${base.fm}/store_order/price`, { params: params })
    },
    //工商银行支付
    storeOrderIBCPayPrepayResult(params) {
        return axios.post(`${base.fm}/store_pay/gateway_icbc/prepay_order_result`, qs.stringify(params));
    },
    //攻略模块
    travelGuideList(params) {
        return axios.get(`${base.fm}/travel_guide/modulesub_list`, { params: params })
    },
    //评论
    reviewListAPI(params) {
        return axios.get(`${base.fm}/review/list`, { params: params })
    },
    //获取皮克球日期
  pickleballDateScheme(id){
    return axios.get(`${base.fm}/store_order/date_scheme/pickleball/list?commodity_id=${id}`)
  },
  //获取皮克球方案
  pickleballScheme(id){
    return axios.get(`${base.fm}/store_order/sku/pickleball/list?commodity_id=${id}`)
  },
   pickleballSku(params){
    return axios.get(`${base.fm}/store_order/pickleball/sku`,{params:params})
   }
}

export default strategy;


// WEBPACK FOOTER //
// ./src/api/strategy.js